import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WhiteLabel } from '../models/white-label';

@Injectable({
  providedIn: 'root',
})
export class WhiteLabelService {
  private baseUrl = `${environment.basePath}/open`;

  constructor(private http: HttpClient) {}

  /*
   * getWhiteLabel
   * @Param white label uuid
   */
  getWhiteLabel(): Observable<WhiteLabel> {
    return this.http.get<WhiteLabel>(
      `${this.baseUrl}/find-label`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }
}
